import React, { useEffect, useState } from "react";
import { Button } from "../ui/Button";

// Modal "Solicitar aprovação": aprovador padrão = gestor do solicitante
// (pré-preenchido), editável pelo analista. O aprovador decide por e-mail
// (links sem login) + sininho.
const ApprovalRequestModal = ({ isOpen, onClose, ticket, defaultApprover, onSubmit }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setEmail(defaultApprover?.email || "");
      setName(defaultApprover?.name || "");
      setMessage("");
      setSaving(false);
    }
  }, [isOpen, defaultApprover]);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!email.trim() || !email.includes("@")) {
      alert("Informe um e-mail de aprovador válido.");
      return;
    }
    setSaving(true);
    try {
      await onSubmit({ approver_email: email.trim(), approver_name: name.trim(), message: message.trim() });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-lg max-h-[92vh] overflow-y-auto rounded-xl bg-white p-6 shadow-xl">
        <div className="flex justify-between items-center mb-1">
          <h2 className="text-lg font-semibold text-gray-900">Solicitar aprovação — #{ticket?.id}</h2>
          <Button variant="ghost" size="icon" onClick={onClose} aria-label="Fechar">✕</Button>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          O chamado fica <strong>aguardando aprovação</strong>. O aprovador recebe um e-mail com os botões
          Aprovar/Reprovar (sem precisar logar). Por padrão, sugerimos o gestor do solicitante.
        </p>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">E-mail do aprovador</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="gestor@empresa.com"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {!defaultApprover?.email && (
              <p className="mt-1 text-xs text-amber-600">Solicitante sem gestor cadastrado — informe o aprovador manualmente.</p>
            )}
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Nome do aprovador (opcional)</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ex.: Maria Gerente"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-gray-700">Justificativa do pedido (opcional)</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={3}
              placeholder="Contexto para o aprovador decidir (custo, motivo, etc.)."
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={saving}>Cancelar</Button>
          <Button onClick={handleConfirm} disabled={saving}>
            {saving ? "Enviando..." : "Solicitar aprovação"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalRequestModal;
